import { Link } from 'react-router-dom';
import BrandLogo from '@/components/common/BrandLogo';

const columns = [
  {
    title: 'Product',
    links: [
      { label: 'Points engine', href: '#products' },
      { label: 'Rewards', href: '#products' },
      { label: 'Tiers', href: '#products', badge: 'NEW' },
      { label: 'Advertise', href: '/advertise' },
      { label: 'Sponsors', href: '/sponsor' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'Retail', href: '#solutions' },
      { label: 'Food & drink', href: '#solutions' },
      { label: 'E-commerce', href: '#solutions' },
      { label: 'Fintech', href: '#solutions' },
    ],
  },
  {
    title: 'Pricing',
    links: [
      { label: 'Plans', href: '#pricing' },
      { label: 'Compare plans', href: '#pricing' },
    ],
  },
  {
    title: 'Developers',
    links: [
      { label: 'API reference', href: '/docs' },
      { label: 'Dashboard', href: '/dashboard' },
      { label: 'Status', href: '#' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Help center', href: '#faq' },
      { label: 'Contact sales', href: '#contact' },
      { label: 'Security', href: '#security' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of service', href: '#' },
      { label: 'Privacy policy', href: '#' },
      { label: 'Cookie policy', href: '#' },
    ],
  },
];

const linkClass = 'text-xs text-white/55 hover:text-white transition-colors';

export default function Footer() {
  return (
    <footer className="w-full bg-[#1f2329] text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-12 pb-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8">
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label} className="flex items-center gap-1.5">
                    {link.href.startsWith('/') ? (
                      <Link to={link.href} className={linkClass}>
                        {link.label}
                      </Link>
                    ) : (
                      <a href={link.href} className={linkClass}>
                        {link.label}
                      </a>
                    )}
                    {'badge' in link && link.badge && (
                      <span className="text-[9px] font-bold rounded bg-gradient-to-r from-[#ff9a1f] to-[#ff5c5c] px-1 py-px">{link.badge}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-5">
          <div className="flex items-center gap-5">
            <Link to="/" className="flex items-center gap-2">
              <BrandLogo className="w-7 h-7" />
              <span className="font-heading font-bold">LoyaltyBridge</span>
            </Link>
            <div className="flex items-center gap-2">
              {[
                { icon: 'ri-telegram-fill', label: 'Telegram', bg: 'bg-[#2aabee]' },
                { icon: 'ri-facebook-fill', label: 'Facebook', bg: 'bg-[#1877f2]' },
                { icon: 'ri-linkedin-fill', label: 'LinkedIn', bg: 'bg-[#0a66c2]' },
                { icon: 'ri-youtube-fill', label: 'YouTube', bg: 'bg-[#ff0033]' },
                { icon: 'ri-github-fill', label: 'GitHub', bg: 'bg-[#4b5563]' },
              ].map((s) => (
                <a key={s.label} href="#" rel="nofollow" aria-label={s.label} className={`w-6 h-6 rounded-full ${s.bg} flex items-center justify-center text-xs hover:brightness-110`}>
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-4 text-xs text-white/55">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-mail-line" /> hello@loyaltybridge.example
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-global-line" /> English
            </span>
          </div>
        </div>
        <p className="mt-5 text-[11px] text-white/35">© 2026 LoyaltyBridge. All rights reserved.</p>
      </div>
    </footer>
  );
}
